import request from '@/utils/request'
import { baseURL } from '@/utils/getawayModule'

/***
 *
 * 获取优惠券列表 get
 * @param type 人员类型 是不是vip
 * @return request
 * */
export function getCouponsByType(query, search) {
  return request({
    url: `${baseURL.businessApi}/select/coupon`,
    method: 'post',
    data: search,
    params: query
  })
}

/***
 *
 * 添加或跟新优惠券 post
 * @param coupon 优惠券对象
 * @return request
 * */
export function editCoupon(coupon) {
  return request({
    url: `${baseURL.businessApi}/coupon`,
    method: 'post',
    data: coupon
  })
}

/***
 *
 * 查询这些优惠券是否使用
 * @param ids 优惠券id
 * @return request
 * */
export function isUseCoupon(ids) {
  return request({
    url: `${baseURL.businessApi}/is_use/coupon/${ids}`,
    method: 'get'
  })
}

/***
 *
 * 删除优惠券 post
 * @param id 优惠券ID
 * @return request
 * */
export function delCoupon(ids) {
  return request({
    url: `${baseURL.businessApi}/del/coupon/${ids}`,
    method: 'delete',
  })
}

/***
 *
 * 邮件发送优惠券 post
 * @param users 用户们
 * @param coupons 优惠券
 * @return request
 * */
export function issueSmsCouponBatch(users, coupons, type) {
  return request({
    url: `${baseURL.businessApi}/coupon_use/email_issue`,
    method: 'post',
    data: {users, coupons, type}
  })
}


/***
 *
 * 查看用户的优惠券情况 post
 * @param users 用户们
 * @param coupons 优惠券
 * @return request
 * */
export function selectCouponUse(query,search) {
  return request({
    url: `${baseURL.businessApi}/coupon_use/`,
    method: 'post',
    data: search,
    params: query
  })
}

/***
 *
 * 消券 post
 * @param ids 使用号
 * @return request
 * */
export function collateCoupon(ids) {
  return request({
    url: `${baseURL.businessApi}/collate_coupon/`,
    method: 'post',
    data: ids,
  })
}

/**
 * 消券记录
 * @param query
 * @param search
 * @returns request
 */
export function getEliminateCouponList(query, search) {
  return request({
    url: `${baseURL.businessApi}/eliminate_coupon`,
    method: 'post',
    data: search,
    params: query
  })
}